<div class=" " *ngIf="(userState | async).user !== null">
  <h5 class="mb-3">Profile informations</h5>
  <p>
    E-mail address: <strong>{{(userState | async).user.username}}</strong>
  </p>
</div>

<app-user-edit-password></app-user-edit-password>



